import { createSelector, createSlice } from '@reduxjs/toolkit'
import type { MixedUserFieldsFragment, ResourceUser } from '@salescore/client-api'
import { Array, HashMap, Option } from 'effect'
import { isNotNullish } from 'effect/Predicate'

export interface MiscState {
  mixedUsers: MixedUserFieldsFragment[]
}

const initialState: MiscState = {
  mixedUsers: [],
}

export const miscSlice = createSlice({
  name: 'misc',
  initialState,
  selectors: {
    selectMixedUsers: (state) => state.mixedUsers,
  },
  reducers: {
    setMixedUsers: (state: MiscState, action: { payload: MixedUserFieldsFragment[] }) => {
      // eslint-disable-next-line no-param-reassign -- Immerなので問題ない
      state.mixedUsers = action.payload
    },
  },
})

export const { selectMixedUsers } = miscSlice.selectors
export const { setMixedUsers } = miscSlice.actions
export default miscSlice.reducer

export const selectGetUser = createSelector([selectMixedUsers], (users: MixedUserFieldsFragment[]) => {
  const map = HashMap.fromIterable(Array.map(users, (u) => [u.resourceUser.id, u.resourceUser]))
  return (userId: string): ResourceUser | undefined => HashMap.get(map, userId).pipe(Option.getOrUndefined)
})

export const selectGetSalesforceUser = createSelector([selectMixedUsers], (users: MixedUserFieldsFragment[]) => {
  const map = HashMap.fromIterable(
    Array.flatMapNullishOr(users, (u) =>
      isNotNullish(u.resourceUser.salescore_user_id) ? [u.resourceUser.salescore_user_id, u.resourceUser] : undefined,
    ),
  )
  return (salesforceUserId: string): ResourceUser | undefined =>
    HashMap.get(map, salesforceUserId).pipe(Option.getOrUndefined)
})
